type UnknownRecord = Record<string, unknown>

const isRecord = (value: unknown): value is UnknownRecord =>
  value !== null && typeof value === 'object' && !Array.isArray(value)

export function getApiErrorMessage(
  error: unknown,
  fallback = 'Request failed',
): string {
  if (isRecord(error)) {
    const response = error['response']
    if (isRecord(response)) {
      const data = response['data']
      if (isRecord(data)) {
        const directMessage = data['message']
        if (typeof directMessage === 'string' && directMessage.trim()) {
          return directMessage.trim()
        }
        const nestedError = data['error']
        if (isRecord(nestedError)) {
          const nestedMessage = nestedError['message']
          if (typeof nestedMessage === 'string' && nestedMessage.trim()) {
            return nestedMessage.trim()
          }
        }
      }
    }
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message.trim()
  }
  return fallback
}

export function withApiErrorMessage(error: unknown): Error {
  return new Error(getApiErrorMessage(error))
}
